import React from 'react'

import { dateToUTC } from '../../lib/formats'
import {
  CurrencyTypeProvider,
  MarginTypeProvider,
  DateTypeProvider,
  WrappedTextTypeProvider
} from '../UI/FormatProviders'
import DataGrid from '../UI/DataGrid'

/*
Props:
- projectId: Mandatory! Get actuals for this project.
- disableHeader,
  disablePager,
  disableFilters,
  disableSearch,
  disableVisibility,
  rowClickFn,
  rowDetailComponent: passed down to DataGrid
*/
const ListActuals = props => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'date', title: 'Date' },
    { name: 'actualGrossCost', title: 'Cost' },
    { name: 'actualGrossTotal', title: 'Total' },
    { name: 'actualGrossMargin', title: 'Margin' },
    { name: 'percentageDelta', title: 'A/Q Delta' },
    { name: 'actualGrandTotal', title: 'Total + taxes' }
  ]

  const gridRowMappingFn = actual => {
    const id = actual.id
    const {
      name,
      date,
      actualGrossCost,
      actualGrossTotal,
      actualGrossMargin,
      percentageDelta,
      actualGrandTotal
    } = actual.attributes

    return {
      id,
      name,
      date: dateToUTC(date),
      actualGrossCost,
      actualGrossTotal,
      actualGrossMargin: Number(actualGrossMargin) * 100,
      percentageDelta: Number(percentageDelta) * 100,
      actualGrandTotal
    }
  }

  const gridSorting = [
    { columnName: 'date', direction: 'desc' },
    { columnName: 'name', direction: 'asc' }
  ]
  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'date', width: 160 },
    { columnName: 'actualGrossCost', align: 'right', width: 180 },
    { columnName: 'actualGrossTotal', align: 'right', width: 180 },
    { columnName: 'actualGrossMargin', align: 'right', width: 120 },
    { columnName: 'percentageDelta', align: 'right', width: 120 },
    { columnName: 'actualGrandTotal', align: 'right', width: 180 }
  ]

  // Formatted columns
  const typeProviders = [
    <WrappedTextTypeProvider key={0} for={['name']} />,
    <DateTypeProvider key={2} for={['date']} />,
    <CurrencyTypeProvider
      key={3}
      for={['actualGrossCost', 'actualGrossTotal', 'actualGrandTotal']}
    />,
    <MarginTypeProvider
      key={4}
      for={['actualGrossMargin', 'percentageDelta']}
    />
  ]

  // Server-side filtering
  const filters = { projectId: props.projectId }

  // Passthrough props
  const otherProps = {
    customSubheader: props.customSubheader,
    disableHeader: props.disableHeader,
    disablePager: props.disablePager,
    disableFilters: props.disableFilters,
    disableSearch: props.disableSearch,
    disableVisibility: props.disableVisibility,
    rowClickFn: props.rowClickFn,
    rowDetailComponent: props.rowDetailComponent
  }

  return (
    <React.Fragment>
      <DataGrid
        disableNew
        resourceAPIEndpoint="actuals"
        resourceSingularName="actual"
        resourcePluralName="actuals"
        nameAttribute="name"
        serverFilters={filters}
        gridColumns={gridColumns}
        gridRowMappingFn={gridRowMappingFn}
        gridSorting={gridSorting}
        gridHiddenColumns={gridHiddenColumns}
        tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
        tableColumnExtensions={tableColumnExtensions}
        typeProviders={typeProviders}
        {...otherProps}
      />
    </React.Fragment>
  )
}

export default ListActuals



// WEBPACK FOOTER //
// ./src/components/Quotes/ListActuals.jsx